import { RunningCalculator } from './RunningCalculator.mjs'
import { redact } from '../utils/redact.mjs'

/**
 * FaviconUrlRc stores a map of domain names to their corresponding favicon URLs.
 *
 * The domain names are derived from the URL property 'hostname', boiling down
 * to the main domain without paths.  While not always accurate, this prevents
 * much redundancy in the data, as most paths off of a hostname do not change
 * the favicon, and the metadata events themselves do not recognize paths.
 */
export class FaviconUrlRc extends RunningCalculator {
  data
  constructor(storageObj) {
    super('faviconUrlRc', ['browserRc'])
    try {
      this.data = Object.keys(storageObj?.data || {}).reduce((acc, key) => {
        acc[key] = new Set(storageObj.data[key])
        return acc
      }, {})
    } catch (e) {
      console.error('Error initializing FaviconUrlRc:', e)
      this.data = {}
    }
  }

  toJson() {
    return {
      ...super.toJson(),
      data: Object.keys(this.data).reduce((acc, key) => {
        acc[key] = [...this.data[key]]
        return acc
      }, {}),
    }
  }

  transition(event, stateData) {
    const { secrets, browserRc } = stateData
    let changed = false
    if (browserRc.focusedTab?.url && browserRc.focusedTab?.faviconUrl) {
      if (!this.data[browserRc.focusedTab?.faviconUrl]) {
        this.data[browserRc.focusedTab?.faviconUrl] = new Set()
        changed = true
      }
      const urls = this.data[browserRc.focusedTab?.faviconUrl]
      if (!urls.has(browserRc.focusedTab?.url)) {
        urls.add(browserRc.focusedTab?.url)
        changed = true
      }
    }
    return changed
  }

  getFaviconForUrl(url, secrets) {
    if (!url) return null
    const key = Object.keys(this.data).find((key) =>
      this.data[key].has(redact(url)),
    )
    if (secrets[key]) return secrets[key]
    return null
  }
}
